import React from 'react';

const TutorialsContent = ({ isDarkMode }) => {
  const tutorials = [
    {
      title: 'Mi Primer Dispositivo',
      description: 'Guía paso a paso para agregar un dispositivo de luz controlable remotamente usando un relé y tu ESP32.',
      link: 'tutoriales/mi-primer-dispositivo.html',
    },
    {
      title: 'Visualizando datos de temperatura en el Dashboard',
      description: 'Guía paso a paso para agrear un dispositivo de temperatura y humedad y visualizarlo remotamente usando un DHT11 y tu ESP32',
      link: 'tutoriales/monitor de temperatura y humedad.html',
    },
    {
      title: 'Visualizando datos de temperatura en el Dashboard',
      description: 'Descubre cómo enviar datos de un sensor de temperatura desde tu ESP32 y visualizarlos en tiempo real en tu dashboard.',
      link: '#',
    },
  ];

  const handleDownloadApiPhp = () => {
    const apiPhpContent = `
`;
    const blob = new Blob([apiPhpContent], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `api.php`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    alert(`El archivo api.php ha sido generado y descargado.`);
  };

  const mainBgClass = isDarkMode ? 'bg-gray-800 text-white' : 'bg-gray-50 text-gray-800';
  const cardBgClass = isDarkMode ? 'bg-gray-900' : 'bg-white';
  const titleColorClass = isDarkMode ? 'text-white' : 'text-gray-700';
  const textColorClass = isDarkMode ? 'text-gray-300' : 'text-gray-600';
  const linkColorClass = isDarkMode ? 'text-blue-400 hover:text-blue-300' : 'text-blue-600 hover:text-blue-800';
  const downloadButtonClass = isDarkMode ? 'bg-green-600 hover:bg-green-700 text-white' : 'bg-green-500 hover:bg-green-600 text-white';

  return (
    <main className={`flex-1 p-6 rounded-2xl shadow-xl m-4 ${mainBgClass} transition-colors duration-300`}>
      <h2 className="mb-6 text-3xl font-bold text-center">Tutoriales y Guías</h2>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {tutorials.map((tutorial, index) => (
          <div key={index} className={`p-6 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 ${cardBgClass}`}>
            <h3 className={`mb-3 text-xl font-semibold ${titleColorClass}`}>{tutorial.title}</h3>
            <p className={`${textColorClass}`}>{tutorial.description}</p>
            <a href={tutorial.link} className={`inline-flex items-center font-medium ${linkColorClass} transition-colors mt-4`}>
              Ver Tutorial
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
              </svg>
            </a>
          </div>
        ))}
      </div>
      <div className={`mt-8 p-6 text-center rounded-2xl shadow-lg ${cardBgClass}`}>
        <p className={`text-xl ${textColorClass}`}>¿No encuentras lo que buscas?</p>
        <p className={`mt-2 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Contáctanos para sugerir nuevos tutoriales.</p>
        
      </div>
    </main>
  );
};

export default TutorialsContent;

// DONE